<div>
  <!--{{pdfUrl | json}} -->
    <!-- Muestra el PDF en un iframe -->
    <iframe [src]="pdfUrl" width="100%" height="1000"></iframe>
  </div>
  